// Camada fina sobre o GTM/dataLayer já presente no site (GTM-WBPDGZK).
// Empurra apenas eventos do funil comercial — NUNCA dados pessoais
// (nome/telefone/e-mail), conforme spec §17 / "Boas práticas" do PDF (§8).

function push(event, params = {}) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...sanitize(params) });
  } catch (e) {
    // analytics é best-effort; nunca deve quebrar o fluxo do usuário.
  }
}

// Remove qualquer chave sensível que porventura chegue aqui por engano.
const BLOQUEADO = ['nome', 'name', 'email', 'telefone', 'phone', 'whatsapp', 'cpf'];
function sanitize(params) {
  const out = {};
  Object.keys(params).forEach((k) => {
    if (!BLOQUEADO.includes(k.toLowerCase())) out[k] = params[k];
  });
  return out;
}

// Eventos nomeados conforme o PDF §9 ("Métricas e eventos").
export const analytics = {
  ctaComercialClick: (origem) => push('sales_cta_click', { cta_origin: origem }),
  interesseSolucaoClick: (solucao) => push('solution_interest_click', { solution: solucao }),
  leadFormStart: (origem) => push('lead_form_start', { cta_origin: origem }),
  leadFormSubmitSuccess: (origem, solucao) =>
    push('lead_form_submit_success', { cta_origin: origem, solution: solucao }),
  leadFormSubmitError: (origem, motivo) =>
    push('lead_form_submit_error', { cta_origin: origem, error: motivo }),
  whatsappFloatClick: () => push('whatsapp_float_click'),
  systemAccessClick: (origem) => push('system_access_click', { cta_origin: origem }),
  supportClick: (origem) => push('support_click', { cta_origin: origem }),
};
